import classNames from "classnames";
import React from "react";

const RadioButton = React.forwardRef((props, ref) => {
  const { id, name, label, children, value, selectedValue, onChange, className, readOnly, dataAutomationId, boldedInput } = props;
  let renderedLabel = (<></>);
  if(boldedInput) {
    renderedLabel = (
      <>
        <div className="radBoldedLabel">{label}</div>
        <div className="radLabel">{boldedInput}</div>
      </>
    )
  } else if (label) {
    renderedLabel = label
  } else {
    renderedLabel = children;
  }

  return (
    <div className={classNames("radio-btn__content-wrapper",className)}>
      <input className="radio-btn__input"
        type="radio"
        id={id}
        name={name}
        readOnly={readOnly}
        ref={ref}
        data-automation-id={dataAutomationId}
        onChange={onChange}
        value={value}
        checked={selectedValue === value}
      />
      <label className="radio-btn__label" htmlFor={id}>
        <span className="radio-btn" />
        <React.Fragment>
          {renderedLabel}
        </React.Fragment>
      </label>
    </div>

  );
});

RadioButton.displayName = "RadioButton";

export default RadioButton;
